/* ==========================================================================
   ETWMoney — single source of truth for client-side money formatting.
   The class is NOT named ETWMoney: a top-level class declaration creates a global
   lexical binding that shadows window.ETWMoney, which would break bare
   `ETWMoney.format(...)` call sites.
   ========================================================================== */
class ETWMoneyFormatter {
    constructor() {
        const settings = (window.theme && window.theme.settings) || {};

        this.moneyFormat = settings.moneyFormat || '';
        this.moneyWithCurrencyFormat = settings.moneyWithCurrencyFormat || '';
        this.currencyCodeEnabled = !!settings.currencyCodeEnabled;

        this.fallbackCurrency = 'USD';
        this.tokenPattern = /\{\{\s*(\w+)\s*\}\}/;

        // Presentment currency is read once: Shopify does not mutate it after injection.
        const currency = window.Shopify && window.Shopify.currency;
        const parsedRate = parseFloat(currency && currency.rate);
        const rateIsUsable = Number.isFinite(parsedRate) && parsedRate > 0;

        this.rate = rateIsUsable ? parsedRate : 1;
        this.canConvert = !!(currency && currency.active) && rateIsUsable;
    }

    format(cents) {
        const format = this.currencyCodeEnabled ? this.moneyWithCurrencyFormat : this.moneyFormat;

        if (!format) {
            return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.fallbackCurrency }).format(cents / 100);
        }

        const match = format.match(this.tokenPattern);
        if (!match) return String(cents / 100);

        let value;
        switch (match[1]) {
            case 'amount':                                  value = this.formatWithDelimiters(cents, 2); break;
            case 'amount_no_decimals':                      value = this.formatWithDelimiters(cents, 0); break;
            case 'amount_with_comma_separator':             value = this.formatWithDelimiters(cents, 2, '.', ','); break;
            case 'amount_no_decimals_with_comma_separator': value = this.formatWithDelimiters(cents, 0, '.', ','); break;
            default:                                        value = this.formatWithDelimiters(cents, 2); break;
        }

        return format.replace(this.tokenPattern, value).replace(/<[^>]+>/g, '').trim();
    }

    formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision == null ? 2 : precision;
        thousands = thousands == null ? ',' : thousands;
        decimal = decimal == null ? '.' : decimal;
        if (isNaN(number) || number == null) return '0';

        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);

        return parts[0] + (parts[1] ? decimal + parts[1] : '');
    }

    toPresentment(shopCents) {
        return Math.round(shopCents * this.rate);
    }
}

window.ETWMoney = new ETWMoneyFormatter();
